/**
 * Configuration for pre-filling reserved form fields with existing player/team official data
 *
 * This file centralizes the mapping between form field names and selectedPlayer properties,
 * making it easy to update if section names or field names change in the future.
 */

export interface ReservedField {
  /** The field name as it appears in the form definition */
  fieldName: string
  /** The property key in the selectedPlayer object */
  playerKey: string
}

// Section names - easy to change if CMS/DB labels change
export const TEAM_OFFICIALS_SECTION = 'Team Official'
export const PLAYER_INFO_SECTION = 'Player Info'

// Team Officials form field mappings
export const TEAM_OFFICIAL_FIELDS: ReservedField[] = [
  { fieldName: 'First Name', playerKey: 'name_first' },
  { fieldName: 'Last Name', playerKey: 'name_last' },
  { fieldName: 'Email', playerKey: 'email' },
  { fieldName: 'Birth Date', playerKey: 'birth_date' },
]

// Player form field mappings
export const PLAYER_INFO_FIELDS: ReservedField[] = [
  { fieldName: 'Player First Name', playerKey: 'name_first' },
  { fieldName: 'Player Last Name', playerKey: 'name_last' },
  { fieldName: 'Player Email', playerKey: 'email' },
  { fieldName: 'Player Birth Date', playerKey: 'birth_date' },
  { fieldName: 'Player Position', playerKey: 'player_type_id' },
  {
    fieldName: 'Preferred Jersey Number',
    playerKey: 'preferred_jersey_number',
  },
  {
    fieldName: 'Other Membership Number',
    playerKey: 'other_membership_number',
  },
  {
    fieldName: 'Player Number',
    playerKey: 'player_number',
  },
]
